import { HasuraBaseQuery } from '@anduin/shared';
import { IServerSideGetRowsParams } from 'ag-grid-community';
import { Apollo } from 'apollo-angular';
import { applyRequestSnapshot, TableRequestSnapshot } from '../../../utils';
import { PendingEmailDatasource } from './pending-datasource.service';

export class PendingEmailExportDatasource extends PendingEmailDatasource {
  constructor(
    apollo: Apollo,
    baseQuery: HasuraBaseQuery,
    private readonly requestSnapshot: TableRequestSnapshot,
    overdueHours: number,
  ) {
    super(apollo, baseQuery);
    this.overdueHours = overdueHours;
  }

  getRows(params: IServerSideGetRowsParams): void {
    super.getRows(applyRequestSnapshot(params, this.requestSnapshot));
  }
}
